import { useEffect, useState } from 'react';
import { findScrollAncestor } from '../utils/browser.utils';

export function useDetectSticky<T extends HTMLElement>({
    el,
    direction = 'vertical',
    distance = 0
}: {
    el?: T;
    direction?: 'vertical' | 'horizontal';
    distance?: number;
} = {}) {
    const [isStuck, setIsStuck] = useState(false);

    const [internalEl, setInternalEl] = useState<T | null>(null);
    const _el = el || internalEl;

    useEffect(() => {
        if (!_el) {
            return;
        }
        const scrollAncestor = findScrollAncestor(_el);
        const axis = direction === 'vertical' ? 'top' : 'left';
        function detectSticky() {
            const elementRect = _el.getBoundingClientRect();
            const scrollRect = scrollAncestor.getBoundingClientRect();
            const _isStuck = elementRect[axis] - distance === scrollRect[axis];
            setIsStuck(_isStuck);
        }
        detectSticky();
        const controller = new AbortController();
        scrollAncestor.addEventListener('scroll', detectSticky, controller);

        return () => controller.abort();
    }, [_el, direction, distance]);

    return { isStuck, el: _el, setEl: setInternalEl };
}
